import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Spinner } from "reactstrap";
import { getSections } from "../../../MyApi/section";
import { getStores } from "../../../MyApi/stores";
import AddressInfoForm from "./addressInfoForm";
import FeatureToggle from "./FeatureToggle";
import UploadImages from "./UploadImages";
import WorkHoursModal from "./workinghoursmodal";
import SkeletonWrapper from "../../UI/skeletonWrapper";
import { formatPrice } from "../../../utils/formatPrice";
import Separate from "../../UI/sepreate";
import { toast } from "react-toastify";
import EnhancedSearchStore from "../../UI/enhancedstoresearch";
import EnhancedSearchVendor from "../../UI/enhancedvendorsearch";
import AddEmployeeModal from "../vendorStore";
import { useNavigate } from "react-router-dom";
import { fa } from "zod/v4/locales";

const StoreInfoForm = ({
  onSave,
  isLoading,
  isLoadingMutate,
  isShowComponent,
  errorMessage,
  setErrorMessage,
  setAddress,
  address,
  setLocationError,
  locationError,
  store_id,
  stores: storeData,
  mode,
  data,
  store_name,
  store_type,
}) => {
  const [isWorkingModalOpen, setIsWorkingModalOpen] = useState("");
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    status: "approved",
    note: "",
    logo: "",
    cover_image: "",
    phone: "",
    section_id: "",
    parent_id: "",
    parent_name: "",
    branch_type: "",
    product_classification: "",
    free_delivery_enabled: 1,
    minimum_order_amount: 0,
    tax_rate: 0,
    commission_amount: "",
    commission_type: "",
    is_owner: 1,
    self_delivery_enabled: 1,
    is_active: 1,
    service_fee_percentage: 0,
    orders_enabled: 1,
    iban: "",
    kitchen_capacity: 1,
    avg_prep_time: 1,
    max_prep_time: 1,
    is_featured: 0,
  });

  const days = [
    { name: "الأحد", value: 0 },
    { name: "الإثنين", value: 1 },
    { name: "الثلاثاء", value: 2 },
    { name: "الأربعاء", value: 3 },
    { name: "الخميس", value: 4 },
    { name: "الجمعة", value: 5 },
    { name: "السبت", value: 6 },
  ];

  useEffect(() => {
    if (store_id) {
      setFormData((prev) => ({
        ...prev,
        parent_id: store_id,
        parent_name: store_name,
      }));
    }
    if (store_type) {
      setFormData((prev) => ({ ...prev, branch_type: store_type }));
    }
  }, [store_id]);

  useEffect(() => {
    if (mode === "edit" && Object.values(storeData).length > 0) {
      setFormData((prev) => ({
        ...prev,
        name: storeData.name,
        status: storeData.status,
        note: storeData.note,
        logo: storeData.logo,
        cover_image: storeData.cover_image,
        phone: storeData.phone,
        kitchen_capacity: storeData.store_setting.kitchen_capacity,
        avg_prep_time: storeData.store_setting.avg_prep_time,
        max_prep_time: storeData.store_setting.max_prep_time,
        parent_id: storeData.branch_type === "main" ? "" : storeData.parent?.id,
        parent_name:
          storeData.branch_type === "main"
            ? storeData.name
            : storeData.parent?.name,
        branch_type: storeData.branch_type,
        product_classification: storeData.store_setting.product_classification,
        free_delivery_enabled: storeData.store_setting.free_delivery_enabled
          ? 1
          : 0,
        service_fee_percentage: storeData.store_setting.service_fee_percentage,
        tax_rate: storeData.store_setting.tax_rate,
        minimum_order_amount: storeData.store_setting.minimum_order_amount,
        commission_amount:
          storeData.commission_type === "subscription"
            ? formatPrice(
                storeData.currency_factor,
                storeData.commission_amount,
              )
            : storeData.commission_amount,
        commission_type: storeData.commission_type,
        self_delivery_enabled: storeData.store_setting.self_delivery_enabled
          ? 1
          : 0,
        is_active: storeData.is_active ? 1 : 0,
        iban: storeData.iban,
        section_id: storeData.section.id,
        // Add owner data for edit mode
        owner_id: storeData.owner?.id || "",
        owner_name: storeData.owner?.full_name || "",
      }));
      setAddress((prev) => ({
        ...prev,
        country_id: storeData.address_data.country.id,
        governorate_id: storeData.address_data.governorate.id,
        city_id: storeData.address_data.city.id,
        latitude: storeData.address_data.latitude,
        longitude: storeData.address_data.longitude,
        zone_id: storeData.address_data.zone.id,
        zones_to_cover: storeData.zone_to_cover.map((zone) => zone.id),
      }));
      setHours(storeData.working_days);
    }
  }, [data]);

  const [hours, setHours] = useState(
    days.map((d) => ({
      day_of_week: d.value,
      open_time: "",
      close_time: "",
    })),
  );

  const MAX_FILE_SIZE = 12 * 1024 * 1024;
  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
  ];
  const hasHours = hours.some((hour) => hour.open_time && hour.close_time);
  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files?.[0];
      if (!file) return;

      if (!ALLOWED_TYPES.includes(file.type)) {
        toast.error("نوع الصورة غير مسموح به (JPG, PNG, GIF, SVG)");
        e.target.value = "";
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error("حجم الصورة يجب ألا يزيد عن 12 ميجا");
        e.target.value = "";
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
            ? 1
            : 0
          : type === "file"
            ? files[0]
            : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      // Ensure owner_id is included in the form data
      const formDataWithOwner = {
        ...formData,
        owner_id: formData.owner_id || "",
        owner_name: formData.owner_name || "",
      };
      onSave(formDataWithOwner, hours);
    }

    setValidated(true);
  };
  const openModal = () => {
    setIsWorkingModalOpen(true);
  };
  const closeModal = () => {
    setIsWorkingModalOpen(false);
  };

  const sectionQuery = useQuery("getSections", () => getSections("store"));
  const storesQuery = useQuery("getStores", getStores);

  const sections = sectionQuery.data?.data?.sections || [];
  const stores = storesQuery.data?.data?.Stores || [];

  return (
    <form
      onSubmit={handleSubmit}
      noValidate
      className={`needs-validation ${validated ? "was-validated" : ""} ${
        isShowComponent ? "d-block" : "d-none"
      }`}
    >
      <div className="row add">
        <h6 className="mb-3">معلومات المتجر</h6>

        {/* المالك */}
        {formData.branch_type === "branch" ? null : (
          <div className="row mb-3 align-items-end">
            <div className="col-md-9">
              <label className="form-label">المالك</label>
              <EnhancedSearchVendor
                setVendorId={(vendorId, vendorName) =>
                  setFormData((prev) => ({
                    ...prev,
                    owner_id: vendorId,
                    owner_name: vendorName,
                  }))
                }
                value={
                  formData.owner_id
                    ? { id: formData.owner_id, full_name: formData.owner_name }
                    : null
                }
                disabled={isLoading}
              />
            </div>
            <div className="col-md-3">
              <button
                type="button"
                className="btn btn-primary mt-2"
                onClick={() => setIsVendorModalOpen(true)}
              >
                + إضافة مالك جديد
              </button>
            </div>
          </div>
        )}
        {/* اسم المتجر */}
        <div className="col-md-6 mb-3">
          <label className="form-label" data-test-id="store-name-label">
            اسم المتجر
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              placeholder="أدخل اسم المتجر"
              required
              data-test-id="form-store-name"
            />
            <div className=" invalid-feedback">اسم المتجر مطلوب</div>
          </SkeletonWrapper>
        </div>

        {/* القسم */}
        <div className="col-md-6 mb-3">
          <label className="form-label" data-test-id="section-label">
            القسم
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <select
              name="section_id"
              value={formData.section_id}
              onChange={handleChange}
              className="form-select"
              required
              data-test-id="form-section-select"
            >
              <option value="">اختار قسم</option>
              {sections.map((section) => (
                <option key={section.id} value={section.id}>
                  {section.name}
                </option>
              ))}
            </select>
            <div className=" invalid-feedback">يرجي اختيار القسم</div>
          </SkeletonWrapper>
        </div>

        {/* نوع الفرع */}
        <div className="col-md-6 mb-3">
          <label className="form-label" data-test-id="branch-type-label">
            نوع الفرع
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <select
              name="branch_type"
              value={formData.branch_type}
              onChange={handleChange}
              className="form-select"
              required
              data-test-id="form-branch-type-select"
            >
              <option value="">اختر نوع الفرع</option>
              <option value="main">الفرع الرئيسي</option>
              <option value="branch">فرع فرعي</option>
            </select>
            <div className="invalid-feedback">يرجي اختيار نوع فرع</div>
          </SkeletonWrapper>
        </div>
        <div className="col-md-6 mb-3">
          <label className="form-label" data-test-id="phone-label">
            الهاتف{" "}
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <input
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="form-control"
              required
              data-test-id="form-phone-input"
            />
          </SkeletonWrapper>
          <div className=" invalid-feedback">يرجي ادخال رقم هاتف</div>
        </div>

        <div className="col-12 mb-3">
          <label className="form-label" data-test-id="phone-label">
            رقم الحساب المصرفي (iban){" "}
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <input
              name="iban"
              value={formData.iban}
              onChange={handleChange}
              className="form-control"
              data-test-id="form-iban-input"
            />
          </SkeletonWrapper>
        </div>
        {formData.branch_type === "branch" ? null : (
          <UploadImages
            errorMessage={errorMessage}
            formData={formData}
            handleChange={handleChange}
            storeData={storeData}
            mode={mode}
            isLoading={isLoading}
          />
        )}

        {formData.branch_type === "branch" && (
          <div className="col-12 mb-3">
            <label className="form-label">الفرع الرئيسي</label>
            <EnhancedSearchStore
              type={formData.branch_type}
              setStoreId={(storeId, storeName) => {
                setFormData((prev) => ({
                  ...prev,
                  parent_id: storeId,
                  parent_name: storeName,
                }));
              }}
              value={
                formData.parent_id
                  ? { id: formData.parent_id, name: formData.parent_name }
                  : null
              }
              disabled={isLoading}
            />
          </div>
        )}
        <Separate />
        <h6 className="mb-2 mt-2">عنوان المتجر</h6>
        <AddressInfoForm
          setLocationError={setLocationError}
          locationError={locationError}
          setAddress={setAddress}
          address={address}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          storeData={storeData}
          mode={mode}
          setFormData={setFormData}
          isLoading={isLoading}
          formData={formData}
        />

        {errorMessage["address.latitude"] && (
          <small className="text-danger">
            {errorMessage && errorMessage["address.latitude"][0]}
          </small>
        )}

        <Separate />
        <h6>تفاصيل المتجر</h6>
        <div className="row align-items-end mt-3">
          <div className="col-md-6">
            <label
              className="form-label"
              data-test-id="commission-amount-label"
            >
              نسبة العمولة
            </label>
            <SkeletonWrapper isLoading={isLoading}>
              <input
                type="text"
                name="commission_amount"
                value={formData.commission_amount}
                onChange={handleChange}
                placeholder="أدخل نسبة العمولة"
                className="form-control"
                data-test-id="form-commission-amount"
              />
            </SkeletonWrapper>
          </div>
          <div className="col-md-3">
            <label className="form-label" data-test-id="commission-type-label">
              نوع العمولة
            </label>
            <SkeletonWrapper isLoading={isLoading}>
              <select
                name="commission_type"
                value={formData.commission_type}
                onChange={handleChange}
                className="form-select"
                data-test-id="form-commission-type"
              >
                <option value="">اختار عمولة</option>
                <option value="subscription">subscription</option>
                <option value="commission">commission</option>
              </select>
            </SkeletonWrapper>
          </div>

          <div className="col-md-3">
            <button
              type="button"
              className="btn btn-primary w-100"
              onClick={() =>
                setFormData((prev) => ({ ...prev, commission_amount: "10" }))
              }
              data-test-id="apply-default-commission-btn"
            >
              تطبيق النسبة الإفتراضية
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <label
              htmlFor=""
              className="form-label"
              data-test-id="tax-rate-label"
            >
              الضريبة
            </label>
            <SkeletonWrapper isLoading={isLoading}>
              <input
                name="tax_rate"
                type="number"
                min={0}
                value={formData.tax_rate}
                className="form-control"
                onChange={handleChange}
                data-test-id="form-tax-rate"
                step="0.01"
              />
            </SkeletonWrapper>
          </div>
          <div className="col-md-6">
            <label
              htmlFor=""
              className="form-label"
              data-test-id="service-fee-label"
            >
              تكلفة الخدمة
            </label>
            <SkeletonWrapper isLoading={isLoading}>
              <input
                name="service_fee_percentage"
                min={0}
                type="number"
                value={formData.service_fee_percentage}
                className="form-control"
                onChange={handleChange}
                data-test-id="form-service-fee"
              />
            </SkeletonWrapper>
          </div>
        </div>

        <div className="col-6">
          <label htmlFor="" className="form-label">
            سعه المطبخ
          </label>
          <input
            name="kitchen_capacity"
            type="number"
            className="form-control"
            onChange={handleChange}
            value={formData.kitchen_capacity}
          />
        </div>
        <div className="col-6">
          <label htmlFor="" className="form-label">
            متوسط وقت التحضير
          </label>
          <input
            name="avg_prep_time"
            type="number"
            className="form-control"
            onChange={handleChange}
            value={formData.avg_prep_time}
          />
        </div>
        <div className="col-12">
          <label htmlFor="" className="form-label">
            أقصى وقت تحضير
          </label>
          <input
            name="max_prep_time"
            type="number"
            className="form-control"
            onChange={handleChange}
            value={formData.max_prep_time}
          />
        </div>

        <div className="col-12">
          <label
            htmlFor=""
            className="form-label"
            data-test-id="minimum-order-label"
          >
            الحد الأدني للطلب
          </label>
          <SkeletonWrapper isLoading={isLoading}>
            <input
              name="minimum_order_amount"
              type="number"
              min={0}
              className="form-control"
              value={formData.minimum_order_amount}
              onChange={handleChange}
              data-test-id="form-minimum-order"
            />
          </SkeletonWrapper>
        </div>

        <h6 className="form-label">ساعات العمل</h6>
        <div className="col-12">
          <div className="work-hours-box" onClick={openModal}>
            {hasHours ? (
              <span> تم إضافة ساعات عمل</span>
            ) : (
              <span> اضغط لإضافة ساعات العمل </span>
            )}
          </div>
          {Object.keys(errorMessage).some((key) =>
            key.startsWith("working_days"),
          ) && <small className="text-danger d-block">ادخل ساعات العمل</small>}
        </div>

        {isWorkingModalOpen && (
          <WorkHoursModal
            isOpen={isWorkingModalOpen}
            setHours={setHours}
            storeData={storeData}
            mode={mode}
            hours={hours}
            days={days}
            onClose={closeModal}
          />
        )}

        {isVendorModalOpen && (
          <AddEmployeeModal
            show={isVendorModalOpen}
            onClose={() => setIsVendorModalOpen(false)}
            refetch={() => {}}
            modalMode="create"
            store_id={store_id}
            is_store={false}
            store_name=""
            onVendorCreated={(vendorData) => {
              // vendorData contains the created vendor object
              setFormData((prev) => ({
                ...prev,
                owner_id: vendorData.id,
                owner_name: vendorData.full_name,
              }));
              setIsVendorModalOpen(false);
            }}
          />
        )}
        <Separate />
        {/* الحالة */}
        <h6 className="mt-3 ">الحالة:</h6>
        <div className="col-12 d-flex justify-content-between align-items-center mt-4 mb-4">
          <div>
            <h5>حالة المتجر:</h5>
            <p>التحكم في حالة المتجر على المنصة</p>
          </div>
          <label className="switch">
            <input
              type="checkbox"
              name="is_active"
              checked={formData.is_active === 1}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  is_active: e.target.checked ? 1 : 0,
                }))
              }
              data-test-id="form-store-status-toggle"
            />

            <span className="slider round"></span>
          </label>
        </div>
        <Separate />
        {/* مميزات المتجر */}
        <h6 className="mt-3 fw-bold">مميزات المتجر:</h6>

        <FeatureToggle
          label="التسليم الذاتي"
          name="self_delivery_enabled"
          checked={formData.self_delivery_enabled === 1}
          onChange={handleChange}
          isLoading={isLoading}
          desc="التحكم في حالة المتجر علي المنصة"
        />

        <FeatureToggle
          label="عرض التوصيل المجاني"
          name="free_delivery_enabled"
          checked={formData.free_delivery_enabled}
          onChange={handleChange}
          isLoading={isLoading}
          desc="عرض شارة التوصيل مجاني"
        />
        <FeatureToggle
          label="متجر مميز"
          name="is_featured"
          checked={formData.is_featured}
          onChange={handleChange}
          isLoading={isLoading}
        />

        <div className="d-flex align-items-center gap-2 mt-3">
          <button
            className="btn btn-primary"
            type="submit"
            disabled={isLoadingMutate}
          >
            {isLoadingMutate ? (
              <Spinner size="sm" />
            ) : mode === "edit" ? (
              "تأكيد تعديل المتجر"
            ) : (
              " تأكيد إضافة المتجر"
            )}
          </button>
          <button
            type="button"
            className="btn btn-white"
            onClick={() => navigate(-1)}
          >
            رجوع
          </button>
        </div>
      </div>
    </form>
  );
};

export default StoreInfoForm;
